import axios from 'axios'
import config from 'config'

export const getEmptyFormData = () => ({
  elements: [],
  htmlName: '',
  action: '',
})

export class EmilyClient {
  constructor(client) {
    this.client = client
  }

  async getForm(formGUID) {
    return this.client.get(`external/getForm/${formGUID}`)
  }

  async submitForm(values) {
    const data = Object.entries(values)
      .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
      .join('&')
    return this.client.post('lead-submit', data, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    })
  }
}

export function emilyFromConfig() {
  return new EmilyClient(axios.create({ baseURL: `${config.emilyURL}` }))
}
